import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import config from "../../../config";
import { useDevice } from "../../../providers/DeviceProvider";
import { DispatchProvider } from "./providers/DispatchProvider";
import DesktopRecentlyCompletedView from "./views/DesktopRecentlyCompletedView";
import MobileRecentlyCompletedView from "./views/MobileRecentlyCompletedView";

const useStyles = makeStyles()(
  (theme) => ({
    noBackground: {
      background: "none",
      overflow: "visible !important"
    }
  })
);

export default function RecentlyCompletedPage() {
  return (
    <DispatchProvider>
      <RecentlyCompletedLayout />
    </DispatchProvider>
  );
}

export function RecentlyCompletedLayout() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { slim } = useDevice();


  return (
    <ResponsivePage
      title={t("dispatch:recentlyCompleted:title")}
      maxWidth={config.pageSize.full}
      className={slim ? classes.noBackground : undefined}
      backButton
    >

      {
        slim ? (
          <MobileRecentlyCompletedView />
        ) : (
          <DesktopRecentlyCompletedView />
        )
      }

    </ResponsivePage>
  );
}